import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBaseService } from '../core/service-base.service';
import { Lot } from '../+state/lots/lot';
import { GenericDataService } from '../shared/generic-data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LotService extends GenericDataService<Lot> {
  endpointName = '/lot';

  constructor(http: HttpClient, serviceBase: ServiceBaseService) {
    super(http, serviceBase);
  }

  getQrCode(lotId: string): Observable<Blob> {
    return this.http.get(
      `${this.serviceBase.getServiceBase()}${this.endpointName}/${lotId}/qrcode`,
      { ...this.serviceBase.getHeaders(), responseType: 'blob' }
    );
  }

  copyLot(lotId: string): Observable<Lot> {
    return this.http.post<Lot>(
      `${this.serviceBase.getServiceBase()}${this.endpointName}/${lotId}/copy`,
      {},
      this.serviceBase.getHeaders()
    );
  }
}
